import { Alignment, Theme } from '@philips-internal/oswald-ui-constants';
import { bool, eventListener, number, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { RecaptchaSize, RecaptchaVersion } from './recaptcha-constants.js';
const recaptchaCheckboxSupportedAlignments = [
    Alignment.CENTER,
    Alignment.LEFT,
    Alignment.RIGHT,
];
const RecaptchaProperties = {
    alignment: {
        defaultValue: Alignment.LEFT,
        type: oneOf(recaptchaCheckboxSupportedAlignments),
    },
    enabled: {
        defaultValue: true,
        type: bool,
    },
    onChange: {
        type: eventListener,
    },
    siteKey: {
        defaultValue: '',
        type: string,
    },
    size: {
        defaultValue: RecaptchaSize.NORMAL,
        type: oneOf(enumValues(RecaptchaSize)),
    },
    tabIndex: {
        defaultValue: 0,
        type: number,
    },
    theme: {
        defaultValue: Theme.LIGHT,
        type: oneOf(enumValues(Theme)),
    },
    type: {
        defaultValue: 'image',
        type: string,
    },
    value: {
        type: string,
    },
    version: {
        defaultValue: RecaptchaVersion.V2,
        type: oneOf(enumValues(RecaptchaVersion)),
    },
};
export { RecaptchaProperties, };
//# sourceMappingURL=recaptcha-types.js.map